/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBranch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7 2v12.126a4.007 4.007 0 0 1 2.862 2.827 7.993 7.993 0 0 0 7.092-7.092 4 4 0 1 1 2.007.023 9.994 9.994 0 0 1-9.077 9.078A4.001 4.001 0 1 1 5 14.126V2zM6 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM18 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBranch as Branch };
